import { Product } from "../interfaces/products";

export enum ProductType {
    AMA_DRAINER_3 = 'ama-drainer-3',
    AMA_DRAINER_4_5 = 'ama-drainer-4-5',
    AMA_DRAINER_BOX_UNTERFLUR = 'ama-drainer-box-unterflur',
    AMA_DRAINER_BOX_UEBERFLUR = 'ama-drainer-box-ueberflur',
    AMAPORTER = 'amaporter',
    AMAREX = 'amarex',

    BOA_COMPACT_EKB = 'boa-compact-ekb',
    BOA_CONTROL_DPR = 'boa-control-dpr',
    BOA_CONTROL_IMS = 'boa-control-ims',
    BOA_CONTROL_SBV = 'boa-control-sbv',
    BOA_H = 'boa-h',
    BOA_RVK = 'boa-rvk',
    BOA_SYSTRONIC_EPIC = 'boa-systronic-epic',
    BOATRONIC_MP = 'boatronic-mp',
    BOAX_MAT = 'boax-mat',
    BOAX_S_SF = 'boax-s-sf',

    CALIO_PRO_PLUS = 'calio',
    CALIO_PRO_PLUS_Z = 'calio-z',
    CALIO_S_PRO = 'calio-s-pro',
    CALIO_THERM_S_PRO = 'calio-therm-s-pro',
    CK_800 = 'ck-800',
    COMPACTA = 'compacta',

    DELTA_COMPACT = 'delta-compact',
    DELTA_MACRO = 'delta-macro',
    DELTA_PRIMO_SVP = 'delta-primo-svp',

    ECOLINE_GT_40 = 'ecoline-gt-40',
    ETABLOC = 'etabloc',
    ETACHROM = 'etachrom',
    ETALINE = 'etaline',
    ETALINE_SYT = 'etaline-syt',
    ETALINE_Z = 'etaline-z',
    ETANORM = 'etanorm',
    ETANORM_FXV = 'etanorm-fxv',
    ETASECO = 'etaseco',

    FILTRA = 'filtra',

    HPK = 'hpk',
    HYADUO_2_D_FL_COMPACT = 'hyaduo-2-d-fl-compact',
    HYASOLO_2_D_FL_COMPACT = 'hyasolo-2-d-fl-compact',
    HYA_RAIN_2_PLUS = 'hya-rain-2-plus',

    ISORIA_10_16 = 'isoria-10-17',
    IXO_PRO = 'ixo-pro',

    KSB_SAFETY_BOOST = 'ksb-safety-boost',

    LEVELCONTROL_BASIC_2 = 'levelcontrol-basic-2',

    MAGNOCHEM = 'magnochem',
    MAGNOCHEM_BLOC = 'magnochem-bloc',

    MEGA_CPK = 'mega-cpk',
    MINI_COMPACTA = 'mini-compacta',
    MOVITEC = 'movitec',
    MOVITEC_VCI = 'movitec-vci',
    MULTI_ECO = 'multi-eco',

    SERIE_2000 = 'serie-2000',
    SISTO_16_RGAMAXX = 'sisto-16rgamaxx',
    SISTO_16_TWA = 'sisto-16twa',
    SISTO_RSK = 'sisto-rsk',

    UPA = 'upa',

    //french products
    BOA_CVE_IMS = 'boa-cve-ims',
    BOA_CONTROL_PIC = 'boa-control-pic',
    BOATRONIC_MS_420 = 'boatronic-ms-420',
    HYA_RAIN_N = 'hya-rain-n',
    DELTA_BASIC_COMPACT_MVP = 'delta-basic-compact-mvp',
}

type ProductsProps = {
    [key in ProductType]: Product
}

export const products: ProductsProps = {
    [ProductType.AMA_DRAINER_3]: {},
    [ProductType.AMA_DRAINER_4_5]: {},
    [ProductType.AMA_DRAINER_BOX_UNTERFLUR]: {},
    [ProductType.AMA_DRAINER_BOX_UEBERFLUR]: {},
    [ProductType.AMAPORTER]: {},
    [ProductType.AMAREX]: {},

    [ProductType.BOA_COMPACT_EKB]: {},
    [ProductType.BOA_CONTROL_DPR]: {},
    [ProductType.BOA_CONTROL_IMS]: {
        new: true,
    },
    [ProductType.BOA_CONTROL_SBV]: {},
    [ProductType.BOA_H]: {},
    [ProductType.BOA_RVK]: {},
    [ProductType.BOA_SYSTRONIC_EPIC]: {
        new: true,
    },
    [ProductType.BOATRONIC_MP]: {
        new: true,
    },
    [ProductType.BOAX_MAT]: {},
    [ProductType.BOAX_S_SF]: {},

    [ProductType.CALIO_PRO_PLUS]: {
        new: true,
    },
    [ProductType.CALIO_PRO_PLUS_Z]: {
        new: true,
    },
    [ProductType.CALIO_S_PRO]: {},
    [ProductType.CALIO_THERM_S_PRO]: {},
    [ProductType.CK_800]: {},
    [ProductType.COMPACTA]: {},

    [ProductType.DELTA_COMPACT]: {},
    [ProductType.DELTA_MACRO]: {},
    [ProductType.DELTA_PRIMO_SVP]: {},

    [ProductType.ECOLINE_GT_40]: {},
    [ProductType.ETALINE]: {},
    [ProductType.ETABLOC]: {},
    [ProductType.ETACHROM]: {},
    [ProductType.ETALINE_SYT]: {},
    [ProductType.ETALINE_Z]: {},
    [ProductType.ETANORM]: {},
    [ProductType.ETANORM_FXV]: {},
    [ProductType.ETASECO]: {},

    [ProductType.FILTRA]: {},

    [ProductType.HPK]: {},
    [ProductType.HYADUO_2_D_FL_COMPACT]: {},
    [ProductType.HYASOLO_2_D_FL_COMPACT]: {},
    [ProductType.HYA_RAIN_2_PLUS]: {
        new: true,
    },

    [ProductType.ISORIA_10_16]: {},
    [ProductType.IXO_PRO]: {},

    [ProductType.KSB_SAFETY_BOOST]: {},

    [ProductType.LEVELCONTROL_BASIC_2]: {},

    [ProductType.MAGNOCHEM]: {},
    [ProductType.MAGNOCHEM_BLOC]: {},
    [ProductType.MEGA_CPK]: {},
    [ProductType.MINI_COMPACTA]: {},
    [ProductType.MOVITEC]: {},
    [ProductType.MOVITEC_VCI]: {},
    [ProductType.MULTI_ECO]: {},

    [ProductType.SERIE_2000]: {},
    [ProductType.SISTO_16_RGAMAXX]: {},
    [ProductType.SISTO_16_TWA]: {},
    [ProductType.SISTO_RSK]: {},

    [ProductType.UPA]: {},

    //french products
    [ProductType.BOA_CVE_IMS]: {},
    [ProductType.BOA_CONTROL_PIC]: {},
    [ProductType.BOATRONIC_MS_420]: {},
    [ProductType.HYA_RAIN_N]: {},
    [ProductType.DELTA_BASIC_COMPACT_MVP]: {},
};
